const TOKEN_KEY = "badger_access_token";
const EMAIL_KEY = "badger_auth_email";
const EXPIRES_AT_KEY = "badger_auth_expires_at";

export function getLocalAccessToken(): string | null {
  const token = sessionStorage.getItem(TOKEN_KEY);
  if (!token) {
    return null;
  }

  const expiresAt = sessionStorage.getItem(EXPIRES_AT_KEY);
  if (expiresAt && Date.now() >= Number(expiresAt)) {
    clearLocalAuth();
    return null;
  }

  return token;
}

export function saveLocalAuth(accessToken: string, email: string, expiresInSeconds: number) {
  sessionStorage.setItem(TOKEN_KEY, accessToken);
  sessionStorage.setItem(EMAIL_KEY, email);
  sessionStorage.setItem(
    EXPIRES_AT_KEY,
    String(Date.now() + expiresInSeconds * 1000),
  );
}

export function getLocalAuthEmail(): string | null {
  return sessionStorage.getItem(EMAIL_KEY);
}

export function clearLocalAuth() {
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(EMAIL_KEY);
  sessionStorage.removeItem(EXPIRES_AT_KEY);
}

export function hasLocalAuthSession(): boolean {
  return getLocalAccessToken() !== null;
}
